import { useQuery } from '@tanstack/react-query';
import { api } from '../../../lib/api';

export const useGenerateReports = campaignId => {
  const { refetch } = useQuery({
    queryKey: ['generateReports', campaignId],
    queryFn: () => {
      const params = campaignId ? { campaign_id: campaignId } : {};
      api.post('/client_admin/campaigns/stats_reports', params);
    },
    enabled: false,
  });

  return { generateReport: refetch };
};
